import { Service } from '@tino-frontend/adapters'
import { CSATPayload, CsatRequestSaveBody, SaveFormResponseCSAT } from '@types'

export interface SaveFormResponseCSATBillLocalstorage {
  data: SaveFormResponseCSAT
  createdAt: string
  daysToExpire: string
}
export interface SaveFormResponseCSATInvoiceLocalstorage {
  data: CsatRequestSaveBody
  createdAt: string
  daysToExpire: string
}

export class CSATService {
  constructor(
    private readonly merchantBff: Service,
    private readonly supplyBff: Service,
    private readonly storage: Service
  ) {
    this.merchantBff = merchantBff
    this.supplyBff = supplyBff
  }

  send(companyId: string, payload: CSATPayload) {
    return this.merchantBff.post(
      `/v1/company/${companyId}/surveys-responses`,
      payload
    )
  }

  saveCSATBill(
    companyId: string,
    billId: string,
    data: CsatRequestSaveBody
  ): Promise<void> {
    return this.merchantBff.post(
      `/v1/company/${companyId}/bill/${billId}/csat`,
      data
    )
  }

  saveCSATBillFormResponse(billId: string): Promise<void> {
    return this.storage.post(`CSATFormResponse`, {
      billId: billId,
    })
  }

  removeCSATBillFormResponse(): Promise<void> {
    return this.storage.delete('CSATFormResponse')
  }

  getCSATBillFormResponse(): SaveFormResponseCSATBillLocalstorage | undefined {
    const value = localStorage.getItem('CSATFormResponse')
    return value ? JSON.parse(value) : undefined
  }

  saveCSATInvoice(data: CsatRequestSaveBody): Promise<void> {
    return this.supplyBff.post(`/v1/csat`, data)
  }

  saveCSATInvoiceFormResponse(data: CsatRequestSaveBody): Promise<void> {
    return this.storage.post(`CSATInvoiceFormResponse`, data)
  }

  getCSATInvoiceFormResponse():
    | SaveFormResponseCSATInvoiceLocalstorage
    | undefined {
    const value = localStorage.getItem('CSATInvoiceFormResponse')
    return value ? JSON.parse(value) : undefined
  }

  saveSalespersonCSAT(): Promise<void> {
    return this.storage.post('@true-application/salesperson-csat')
  }

  getSalespersonCSAT():
    | {
        createdAt: string
        daysToExpire: string
      }
    | undefined {
    const value = localStorage.getItem('@true-application/salesperson-csat')
    return value ? JSON.parse(value) : undefined
  }
}
